module.exports = __webpack_public_path__ + "assets/favicon-bf-es.49c230ff.png";